import { apiSlice } from './apiSlice';

export const costCenterApi = apiSlice.injectEndpoints({
   // Adjust baseUrl based on your actual api routing
  endpoints: (builder) => ({
    getCostCenters: builder.query<any, Record<string, any> | void>({
      query: (params) => ({
        url: '/cost-centers',
        params: params || undefined,
      }),
      providesTags: ['CostCenter'],
    }),
    getCostCenterTree: builder.query<any, void>({
      query: () => ({ url: '/cost-centers/tree' }),
      providesTags: ['CostCenterTree'],
    }),
    getCostCenterById: builder.query<any, string | number>({
      query: (id) => ({ url: `/cost-centers/${id}` }),
      providesTags: (result, error, id) => [{ type: 'CostCenter', id }],
    }),
    createCostCenter: builder.mutation<any, any>({
      query: (data) => ({
        url: '/cost-centers',
        method: 'POST',
        data: data,
      }),
      invalidatesTags: ['CostCenter', 'CostCenterTree'],
    }),
    updateCostCenter: builder.mutation<any, { id: string | number; data: any }>({
      query: ({ id, data }) => ({
        url: `/cost-centers/${id}`,
        method: 'PUT',
        data: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'CostCenter', id }, 'CostCenterTree'],
    }),
    deleteCostCenter: builder.mutation<void, string | number>({
      query: (id) => ({
        url: `/cost-centers/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['CostCenter', 'CostCenterTree'],
    }),
    getCostCenterTrialBalance: builder.query<any, Record<string, any> | void>({
      query: (params) => ({
        url: '/cost-centers/reports/trial-balance',
        params: params || undefined,
      }),
    }),
    getIncomeStatement: builder.query<any, Record<string, any> | void>({
      query: (params) => ({
        url: '/cost-centers/reports/income-statement',
        params: params || undefined,
      }),
    }),
    getCostCenterBalanceSheet: builder.query<any, Record<string, any> | void>({
      query: (params) => ({
        url: '/cost-centers/reports/balance-sheet',
        params: params || undefined,
      }),
    }),
    runCurrencyRevaluation: builder.mutation<any, string>({
      query: (asOfDate) => ({
        url: '/cost-centers/currency-revaluation',
        method: 'POST',
        data: { as_of_date: asOfDate },
      }),
    }),
  }),
});

export const {
  useGetCostCentersQuery,
  useLazyGetCostCentersQuery,
  useGetCostCenterTreeQuery,
  useLazyGetCostCenterTreeQuery,
  useGetCostCenterByIdQuery,
  useCreateCostCenterMutation,
  useUpdateCostCenterMutation,
  useDeleteCostCenterMutation,
  useGetCostCenterTrialBalanceQuery: useGetTrialBalanceQuery,
  useLazyGetCostCenterTrialBalanceQuery: useLazyGetTrialBalanceQuery,
  useGetIncomeStatementQuery,
  useLazyGetIncomeStatementQuery,
  useGetCostCenterBalanceSheetQuery: useGetBalanceSheetQuery,
  useLazyGetCostCenterBalanceSheetQuery: useLazyGetBalanceSheetQuery,
  useRunCurrencyRevaluationMutation,
} = costCenterApi;


